import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconResizeSmall$1 = /*@__PURE__*/ proxyCustomElement(class WppIconResizeSmall extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-resize-small", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M5.52778 4.16667C4.77606 4.16667 4.16667 4.77606 4.16667 5.52778V6.69444C4.16667 7.01661 3.9055 7.27778 3.58333 7.27778C3.26117 7.27778 3 7.01661 3 6.69444V5.52778C3 4.13172 4.13172 3 5.52778 3H6.69444C7.01661 3 7.27778 3.26117 7.27778 3.58333C7.27778 3.9055 7.01661 4.16667 6.69444 4.16667H5.52778ZM6.85001 8.63889C6.85001 7.67239 7.63351 6.88889 8.60001 6.88889H11.3222C12.2887 6.88889 13.0722 7.67239 13.0722 8.63889V11.3611C13.0722 12.3276 12.2887 13.1111 11.3222 13.1111H8.60001C7.63351 13.1111 6.85001 12.3276 6.85001 11.3611V8.63889ZM8.60001 8.05556C8.27784 8.05556 8.01668 8.31672 8.01668 8.63889V11.3611C8.01668 11.6833 8.27784 11.9444 8.60001 11.9444H11.3222C11.6444 11.9444 11.9056 11.6833 11.9056 11.3611V8.63889C11.9056 8.31672 11.6444 8.05556 11.3222 8.05556H8.60001ZM14.4722 4.16667C15.2239 4.16667 15.8333 4.77606 15.8333 5.52778V6.69444C15.8333 7.01661 16.0945 7.27778 16.4167 7.27778C16.7388 7.27778 17 7.01661 17 6.69444V5.52778C17 4.13172 15.8683 3 14.4722 3H13.3056C12.9834 3 12.7222 3.26117 12.7222 3.58333C12.7222 3.9055 12.9834 4.16667 13.3056 4.16667H14.4722ZM14.4722 15.8333C15.2239 15.8333 15.8333 15.2239 15.8333 14.4722V13.3056C15.8333 12.9834 16.0945 12.7222 16.4167 12.7222C16.7388 12.7222 17 12.9834 17 13.3056V14.4722C17 15.8683 15.8683 17 14.4722 17H13.3056C12.9834 17 12.7222 16.7388 12.7222 16.4167C12.7222 16.0945 12.9834 15.8333 13.3056 15.8333H14.4722ZM5.52778 15.8333C4.77606 15.8333 4.16667 15.2239 4.16667 14.4722V13.3056C4.16667 12.9834 3.9055 12.7222 3.58333 12.7222C3.26117 12.7222 3 12.9834 3 13.3056V14.4722C3 15.8683 4.13172 17 5.52778 17H6.69444C7.01661 17 7.27778 16.7388 7.27778 16.4167C7.27778 16.0945 7.01661 15.8333 6.69444 15.8333H5.52778Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-resize-small-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-resize-small", "wpp-icon-resize-small-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-resize-small-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-resize-small-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconResizeSmall$1);
      }
      break;
  } });
}

const WppIconResizeSmall = WppIconResizeSmall$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconResizeSmall, defineCustomElement };
